import React, { useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";
import ConstructionCard from "./constructionCards";
import { useGetConstructionDetails } from "../../helperHooks/getDetails";

const ConstructionPage = () => {
  const { data, loading, error } = useGetConstructionDetails();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ minHeight: "70vh", backgroundColor: "#f6f4ef" }}>
      <Box
        sx={{
          px: { xs: 3, md: 8 },
          pt: { xs: 10, md: 15 },
          pb: { xs: 7, md: 10 },
          textAlign: "center",
          backgroundColor: "#eeece5",
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <Typography
            component="p"
            sx={{
              mb: 2,
              color: "#9a794b",
              fontSize: "0.68rem",
              fontWeight: 600,
              letterSpacing: "0.2em",
            }}
          >
            BUILT WITH CARE
          </Typography>
          <Typography
            component="h1"
            variant="h1"
            sx={{
              fontSize: { xs: "2.8rem", md: "4.8rem" },
              lineHeight: 1.08,
            }}
          >
            Our construction
            <br />
            portfolio
          </Typography>
          <Typography
            sx={{
              maxWidth: 680,
              mx: "auto",
              mt: 2.5,
              color: "text.secondary",
              fontSize: { xs: "0.92rem", md: "1rem" },
              lineHeight: 1.8,
            }}
          >
            From the first plan to the final finish, we create enduring homes
            and spaces with thoughtful detail and trusted craftsmanship.
          </Typography>
        </motion.div>
      </Box>

      <Box sx={{ maxWidth: 1480, mx: "auto", px: { xs: 2.5, md: 6 }, py: { xs: 6, md: 9 } }}>
        {loading ? (
          <Typography textAlign="center" color="text.secondary">
            Loading construction projects…
          </Typography>
        ) : error ? (
          <Typography textAlign="center" color="error">
            We couldn&apos;t load construction projects. Please try again later.
          </Typography>
        ) : !data?.length ? (
          <Typography textAlign="center" color="text.secondary">
            Construction projects will be shown here soon.
          </Typography>
        ) : (
          <Grid container spacing={{ xs: 3, md: 4 }}>
            {data.map((project, index) => (
              <Grid item xs={12} sm={6} md={4} key={project.id || index}>
                <ConstructionCard {...project} index={index} />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default ConstructionPage;
